import { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './supabaseClient'
import Auth from './Auth'
import Landing from './Landing'
import Layout from './Layout'
import AdminPanel from './AdminPanel'
import AthleteProfile from './AthleteProfile'
import Terms from './Terms'
import Privacy from './Privacy'

function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Resolve the initial session first — only clear loading once we know
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })

    // Keep session in sync with sign-in/sign-out events after initial load
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) return null

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/athlete/:slug" element={<AthleteProfile />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {!session ? (
          <>
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<Auth />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Navigate to="/pipeline" replace />} />
            <Route path="/login" element={<Navigate to="/pipeline" replace />} />
            <Route path="/admin" element={<AdminPanel user={session.user} />} />
            <Route path="*" element={<Layout user={session.user} />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  )
}

export default App
